module.exports = __webpack_public_path__ + "tl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tl.svg
// module id = 843
// module chunks = 0